import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { configProviderInjectionKey as i } from "../config-provider/src/context.js";
import d from "../locales/common/enUS.js";
import u from "../locales/date/enUS.js";
import { inject as c, computed as n } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function s(t) {
  const {
    mergedLocaleRef: o,
    mergedDateLocaleRef: l
  } = c(i, null) || {}, a = n(() => {
    var e, r;
    return (r = (e = o == null ? void 0 : o.value) === null || e === void 0 ? void 0 : e[t]) !== null && r !== void 0 ? r : d[t];
  });
  return {
    dateLocaleRef: n(() => {
      var e;
      return (e = l == null ? void 0 : l.value) !== null && e !== void 0 ? e : u;
    }),
    localeRef: a
  };
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-locale.js
// module id = 105
// module chunks = 67